import { enumDictionaryToSelectOptions } from '../../../../../shared/utils/enums-to-list-formatter';
import { SelectOption } from '@models/ui-models/select-options';
import { Entity } from "@models/companies/entity";
import { Company } from "@models/companies/company";
import { Trust } from "@models/trusts/trust";
import { CoverLetter } from "@models/documents/cover-letter";
import { CompanyRecord } from '@models/companies/company-record';
import { IndividualRecord } from '@models/individuals/Individual-record';
import { IndividualDto } from '@models/individuals/individual-dto';

export type ITagsEntity = Entity | Company | CompanyRecord | Trust | IndividualDto | IndividualRecord | CoverLetter;

export enum TagActionEnum {
  Assign,
  Override,
  Unassign
}

export enum TagEntityTypeEnum {
  Company,
  Trust,
  Individual,
  CoverLetter
}

export const TagActionDictionary = {
  [TagActionEnum.Assign]: 'Add',
  [TagActionEnum.Unassign]: 'Remove',
  [TagActionEnum.Override]: 'Override',
};

export const ManageTagsModalActionsOptions: SelectOption[] = enumDictionaryToSelectOptions(TagActionDictionary);

export function getTagEntityTypeEnum(entity: ITagsEntity): TagEntityTypeEnum {
  if ('companyType' in entity) {
    // The entity is company
    return TagEntityTypeEnum.Company;
  } else if ('trustType' in entity) {
    // The entity is trust
    return TagEntityTypeEnum.Trust;
  } else if ('individualId' in entity) {
    // The entity is individual
    return TagEntityTypeEnum.Individual;
  } else if ('fileName' in entity) {
    return TagEntityTypeEnum.CoverLetter;
  }

  return TagEntityTypeEnum.Company;
}

export function getTagEntityId(entity: ITagsEntity): string {
  if ('acn' in entity) {
    return entity.entityId;
  } else if ('abn' in entity) {
    return entity.entityId;
  } else if ('individualId' in entity) {
    return entity.individualId;
  } else if ('fileName' in entity) {
    return entity.id;
  }

  return '';
}
